<template>
  <div>
    <h5 class="p-4">Ad Status</h5>
    <report-table
      v-if="!(!loading && results.length === 0)"
      :report="results"
      :stats="stats"
      :fields="fields"
      :showChevrons="false">
      <template slot="bids" slot-scope="data">
        <status-indicator variant="success">
          {{ data.value }}
        </status-indicator>
      </template>
    </report-table>
    <no-results v-else></no-results>
  </div>
</template>

<script>
    import auth from '@/auth'
    import {ReportsApi} from '@/reports/api'
    import ReportTable from '@/reports/components/ReportTable'
    import NoResults from '@/components/NoResults'
    import StatusIndicator from '@/components/StatusIndicator'

    export default {
        props: {
            cid: {type: String, required: false}
        },
        data() {
            return {
                loading: true,
                results: [],
                fields: ['bidder_name', 'cid', 'crid'],
                stats: ['bids', 'clears']
            }
        },
        created() {
            // this.getReport()
        },
        methods: {
            companyId() {
                if (this.cid) {
                    return this.cid
                }
                if (auth.isAdmin()) {
                    return null /* report for all */
                }

                return auth.company().company_id
            },
            getReport() {
                this.loading = true
                return ReportsApi.bqreport(this.query, this).then((data) => {
                    this.results = data.results
                }, (e) => {
                    console.error(e)
                }).finally(() => {
                    this.loading = false
                })
            }
        },
        computed: {
            query() {
                let query = {
                    dateAsMillis: true,
                    fields: this.fields,
                    filters: [],
                    stats: this.stats,
                    endTime: moment().endOf('day').valueOf(),
                    startTime: moment().startOf('day').subtract(1, 'years').valueOf()
                }

                let mode = this.$route.path().split("/")[1]
                if (mode === 'publisher') {
                    query.filters.push({field: 'exchange_id', operator: 'EQUAL', value: 'smartrtb'})
                    query.filters.push({field: 'pub_id', operator: 'EQUAL', value: this.companyId()})
                }
                if (mode === 'demand') {
                    query.filters.push({field: 'bidder_id', operator: 'EQUAL', value: this.companyId()})
                }
                if (mode === 'exchange') {
                    query.filters.push({field: 'exchange_id', operator: 'EQUAL', value: this.companyId()})
                }
                return query
            }
        },
        components: {
            StatusIndicator,
            ReportTable,
            NoResults
        }
    }
</script>



// WEBPACK FOOTER //
// src/reports/pages/AdReview/AdStatus.vue